import { Card } from 'components/common';
import { useCallback } from 'react';
import { SearchPatientKeys } from './SearchPatientForm';
import { UserData } from '../../../../types/users';
import { useSelectUserWithHiddenRefetch } from '../../../../hooks/user/useSelectUserWithUpdate';
import { SangixMainGrid } from '../../../../containers/staff/SangixMainGrid';
import { PatientDetailCard } from '../../../../containers/staff/calendar/bookWithPatient/PatientDetailCard';
import { SearchPatientSelectTable } from './SearchPatientSelectTable';

export interface SearchPatientListProps {
  searchPatientKeys?: SearchPatientKeys;
  selectPatient: (user: UserData | undefined) => void;
}

export const SearchPatientList = ({
  searchPatientKeys,
  selectPatient,
}: SearchPatientListProps) => {
  const {
    setSelectedUser: setPreviewedPatient,
    selectedUser: previewedPatient,
  } = useSelectUserWithHiddenRefetch();

  const previewPatient = useCallback(
    (user) => {
      setPreviewedPatient(user);
    },
    [setPreviewedPatient],
  );

  return (
    <SangixMainGrid
      main={
        <Card>
          <SearchPatientSelectTable
            initialFilters={searchPatientKeys}
            onClose={() => {
              selectPatient(undefined);
            }}
            onSelectPatient={selectPatient}
            onPreviewPatient={previewPatient}
          />
        </Card>
      }
      secondary={
        <>
          {previewedPatient && (
            <PatientDetailCard
              key={previewedPatient.id}
              patient={previewedPatient}
              onPatientSelectButtonClicked={() => {
                selectPatient(previewedPatient);
              }}
              onPatientCloseButtonClicked={() => {
                previewPatient(undefined);
              }}
            />
          )}
        </>
      }
    />
  );
};
